// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pBkV_","rightAdornment":"Header_rightAdornment__1wSSz"};